import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from './base';
import { Project } from '../definitions';
@Injectable()
export class AuditTrailService extends BaseService {
  constructor(private http: HttpClient, @Inject('project') public project: Project) {
    super(project);
  }

  getTaxpayersForQuickSearch(searchTerm: string) {
    const params = new HttpParams().set('searchTerm', searchTerm);

    return this.http.get(`${this.baseUrl}/taxpayers`, { params });
  }

  getUsersForQuickSearch(mode: string, searchTerm: string) {
    const params = new HttpParams().set('searchTerm', searchTerm);

    return this.http.get(`${this.baseUrl}/taxpayers/audit-trail/contacts/${mode}`, { params });
  }

  getAuditTrail(data: AuditTrailQueryData) {
    return this.http.post(`${this.baseUrl}/taxpayers/audit-trail`, data, this.requestOptions);
  }

  sendAuditTrailEmail(auditItemIds: number[]) {
    return this.http.post(
      `${this.baseUrl}/taxpayers/audit-trail/email`,
      { auditItemIds: auditItemIds },
      this.requestOptions,
    );
  }
}

export type AuditTrailQueryData = {
  accountId: number;
  dateType: string;
  fromDate: string;
  toDate: string;
  emailSent: EmailSentOptions;
  changeRequestedUser: number;
  changeActionedUser: number;
};

export type AuditTrailForm = {
  accountId: number;
  dateType: string;
  fromDate: string;
  toDate: string;
  emailSent: string;
  changeRequestedUser: number;
  changeActionedUser: number;
};

type EmailSentOptions = {
  0: boolean;
  1: boolean;
};

export type AuditItem = {
  accountId: number;
  accountName: string;
  auditItemId: number;
  coreItem: string;
  coreOldValue: string | number;
  coreNewValue: string | number; // can be changed to 'any' if necessary
  dateCreated: string;
  membershipChange: string;
  memberName: number;
  groupId: number;
  groupName: number;
  groupMemberType: string;
  userActioned: number;
  userRequested: number;
  emailFlag: number;
  dateEmailSent: string;
};
